import { FC } from "react";
import { Container, Navigation, Section } from "../../../@component/layout";
import { Button } from "../../../@component/buttons";
import { Banner } from "../../../@component/sections/banner";
import { About } from "../../../@component/sections/about";
import { Program } from "../../../@component/sections/program";
import { Impact } from "../../../@component/sections/impact";
import { Location } from "../../../@component/sections/locations";
import { ContactUs } from "../../../@component/sections/contact-us";
import { Faqs } from "../../../@component/sections/faq";
import { Footer } from "../../../@component/layout/footer";
import { Images } from "../../../@assets/images";
import { BannerImage } from "../../../@component/sections/banner-image";
import { AboutFounder } from "../../../@component/sections/about-founder";

export const Home: FC = (props) => {
  return (
    <Section>
      <Navigation />
      {/*<BannerImage />*/}
      {/* <AboutFounder /> */}
      <Location />
      <Program />
      <Impact />
      {/* <Incubator /> */}
      <ContactUs />
      <Faqs
        data={[
          {
            desc: `<span style="font-weight: 400;">Pendaftaran BEKUP akan di buka pada saat Kick-Off BEKUP 2025 tanggal 2 Juni s.d 2 Juli 2025 nanti yaa sobat!</span>`,
            title: "Kapan pendaftaran BEKUP?",
          },
          {
            desc: `<span style="font-weight: 400;">Fokus bidang yang bisa kamu daftarkan di BEKUP 2025 ini adalah transformasi digital dari 17 subsektor ekonomi kreatif yaaa yang meliputi pengembang permainan, arsitektur, desain interior, musik, seni rupa, desain produk, fesyen, kuliner, film, animasi dan video, fotografi, desain komunikasi visual, televisi dan radio, kriya, periklanan, seni pertunjukan, penerbitan, dan aplikasi.</span>`,
            title: "Bidang apa sajakah yang bisa didaftarkan di BEKUP 2025?",
          },
          {
            desc: `<span style="font-weight: 400;">Bisa dong! Untuk skema pendaftaran BEKUP 2025 dibagi menjadi dua yaa sobat yaitu skema create dan skema accelerate. Skema create sendiri merupakan skema dimana bisnis yang diajukan masih berbentuk ide. Sedangkan skema accelerate adalah skema dimana bisnis yang diajukan sudah berjalan.</span>`,
            title: "Apabila bisnis saya masih hanya sebatas ide apakah bisa mengikuti BEKUP 2025?",
          },
          {
            desc: `<p><span style="font-weight: 400;">Dengan mengikuti program BEKUP 2025 tentunya akan ada banyak benefit yang bisa kamu dapatkan, diantaranya :&nbsp;</span></p><ol><li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Professional Network</span></li><li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Acces to Funding</span></li><li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Mentoring Class&nbsp;</span></li><li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">1-on-1 coaching&nbsp;</span></li><li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Certificate</span></li></ol>`,
            title: "Apa sajakah benefit mengikuti Program BEKUP 2025!",
          },
          {
            desc: `<p><span style="font-weight: 400;">Mengenai syarat pendaftaran dan mekanisme pendaftaran BEKUP 2025, kamu bisa mengakses Menu Program BEKUP Create & Accelerate untuk informasi lebih lanjut.</span></p>`,
            title: "Apa sajakah syarat pendaftaran BEKUP 2025?",
          },
        ]}
      />
      <Footer />
    </Section>
  );
};
